export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["Smile"] = "Smile";
    FeedbackType["Frown"] = "Frown";
    FeedbackType["Idea"] = "Idea";
    FeedbackType["Unclassified"] = "Unclassified";
    FeedbackType["Like"] = "Like";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackAgeGroup;
(function (FeedbackAgeGroup) {
    FeedbackAgeGroup["Undefined"] = "Undefined";
    FeedbackAgeGroup["MinorWithoutParentalConsent"] = "MinorWithoutParentalConsent";
    FeedbackAgeGroup["MinorWithParentalConsent"] = "MinorWithParentalConsent";
    FeedbackAgeGroup["NotAdult"] = "NotAdult";
    FeedbackAgeGroup["Adult"] = "Adult";
    FeedbackAgeGroup["MinorNoParentalConsentRequired"] = "MinorNoParentalConsentRequired";
})(FeedbackAgeGroup || (FeedbackAgeGroup = {}));
export var InAppFeedbackQuestionUiType;
(function (InAppFeedbackQuestionUiType) {
    InAppFeedbackQuestionUiType["DropDown"] = "DropDown";
    InAppFeedbackQuestionUiType["MultiSelect"] = "MultiSelect";
    InAppFeedbackQuestionUiType["Rating"] = "Rating";
    InAppFeedbackQuestionUiType["SingleSelect"] = "SingleSelect";
})(InAppFeedbackQuestionUiType || (InAppFeedbackQuestionUiType = {}));
export var InAppFeedbackScenarioType;
(function (InAppFeedbackScenarioType) {
    InAppFeedbackScenarioType["FeatureArea"] = "FeatureArea";
    InAppFeedbackScenarioType["ResponsibleAI"] = "ResponsibleAI";
    InAppFeedbackScenarioType["ChildFeedback"] = "ChildFeedback";
    InAppFeedbackScenarioType["Experience"] = "Experience";
    InAppFeedbackScenarioType["ProductSatisfaction"] = "ProductSatisfaction";
    InAppFeedbackScenarioType["CrashImpact"] = "CrashImpact";
    InAppFeedbackScenarioType["Custom"] = "Custom";
    InAppFeedbackScenarioType["AIThumbsDown"] = "AIThumbsDown";
    InAppFeedbackScenarioType["AIThumbsUp"] = "AIThumbsUp";
})(InAppFeedbackScenarioType || (InAppFeedbackScenarioType = {}));
export var InAppFeedbackQuestionUiBehaviour;
(function (InAppFeedbackQuestionUiBehaviour) {
    InAppFeedbackQuestionUiBehaviour["QuestionNotRequired"] = "QuestionNotRequired";
    InAppFeedbackQuestionUiBehaviour["CommentNotRequired"] = "CommentNotRequired";
    InAppFeedbackQuestionUiBehaviour["CommentRequiredWithLastOption"] = "CommentRequiredWithLastOption";
})(InAppFeedbackQuestionUiBehaviour || (InAppFeedbackQuestionUiBehaviour = {}));
export var FeedbackAuthenticationType;
(function (FeedbackAuthenticationType) {
    FeedbackAuthenticationType["MSA"] = "MSA";
    FeedbackAuthenticationType["AAD"] = "AAD";
    FeedbackAuthenticationType["Unauthenticated"] = "Unauthenticated";
})(FeedbackAuthenticationType || (FeedbackAuthenticationType = {}));
export var FeedbackPolicyValue;
(function (FeedbackPolicyValue) {
    FeedbackPolicyValue["Enabled"] = "Enabled";
    FeedbackPolicyValue["Disabled"] = "Disabled";
    FeedbackPolicyValue["NotConfigured"] = "Not Configured";
})(FeedbackPolicyValue || (FeedbackPolicyValue = {}));
export var FeedbackScreenshotInfoImageFormat;
(function (FeedbackScreenshotInfoImageFormat) {
    FeedbackScreenshotInfoImageFormat["JPEG"] = "jpeg";
    FeedbackScreenshotInfoImageFormat["PNG"] = "png";
})(FeedbackScreenshotInfoImageFormat || (FeedbackScreenshotInfoImageFormat = {}));
export var FeedbackScreenshotSourceType;
(function (FeedbackScreenshotSourceType) {
    FeedbackScreenshotSourceType["AutoCapture"] = "AutoCapture";
    FeedbackScreenshotSourceType["AutoCaptureWithHtml2Canvas"] = "AutoCaptureWithHtml2Canvas";
    FeedbackScreenshotSourceType["ProvidedAtInitialization"] = "ProvidedAtInitialization";
    FeedbackScreenshotSourceType["DynamicallyProvided"] = "DynamicallyProvided";
})(FeedbackScreenshotSourceType || (FeedbackScreenshotSourceType = {}));
export var FeedbackUiType;
(function (FeedbackUiType) {
    FeedbackUiType["SidePane"] = "SidePane";
    FeedbackUiType["Modal"] = "Modal";
    FeedbackUiType["NoSurface"] = "NoSurface";
    FeedbackUiType["CallOut"] = "CallOut";
    FeedbackUiType["NoSurfaceWithoutTitle"] = "NoSurfaceWithoutTitle";
})(FeedbackUiType || (FeedbackUiType = {}));
export var FeedbackHostPlatformType;
(function (FeedbackHostPlatformType) {
    FeedbackHostPlatformType["Windows"] = "Windows";
    FeedbackHostPlatformType["IOS"] = "iOS";
    FeedbackHostPlatformType["Android"] = "Android";
    FeedbackHostPlatformType["WacTaskPane"] = "WacTaskPane";
    FeedbackHostPlatformType["MacOS"] = "MacOS";
    FeedbackHostPlatformType["Web"] = "Web";
})(FeedbackHostPlatformType || (FeedbackHostPlatformType = {}));
//# sourceMappingURL=FeedbackDataTypes.js.map